import { formatDistanceToNow } from 'date-fns';

export const getRelativeTime = (date) => {
    return formatDistanceToNow(new Date(date), { addSuffix: true });
  };